import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

export const BaseHospitalSchema = z.object({
  hospital_id: uuidSchema,
  enterprise_id: uuidSchema,
  tenant_id: uuidSchema,
  hospital_code: z.string().max(50),
  hospital_name: z.string().max(300),
  hospital_type: z.string().max(20),
  ods_code: z.string().max(20).nullable().optional(),
  address_line1: z.string().max(300),
  city: z.string().max(100),
  country_code: z.string().length(2),
  postal_code: z.string().max(20),
  timezone: z.string().max(50),
  locale: z.string().max(10).nullable().optional(),
  is_active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type BaseHospital = z.infer<typeof BaseHospitalSchema>;

/** Schema used to parse raw Prisma rows (Date -> ISO string) before returning */
export const HospitalResponseSchema = BaseHospitalSchema.extend({
  created_at: z.coerce.date().transform((d) => d.toISOString()),
  updated_at: z.coerce.date().transform((d) => d.toISOString()),
});

export type HospitalResponse = z.infer<typeof HospitalResponseSchema>;
